import { clsx } from 'clsx';
import { PropsWithChildren } from 'react';
import { Popover as AriaPopover, PopoverProps } from 'react-aria-components';
import styles from './Popover.module.scss';

const Popover: React.FC<PropsWithChildren<PopoverProps & React.RefAttributes<HTMLElement>>> = ({
  children,
  ...props
}) => {
  return (
    <AriaPopover {...props} className={clsx(styles.popover, props.className)}>
      {children}
    </AriaPopover>
  );
};

export default Popover;
